import { render, staticRenderFns } from "./product-uploader.vue?vue&type=template&id=18c44ee0&"
import script from "./product-uploader.vue?vue&type=script&lang=js&"
export * from "./product-uploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports